import React from 'react'

const index = (props) => {
  return <div>DMM Assistant Edit Page</div>
}

export default index